import { createFileRoute } from '@tanstack/react-router'
import { z } from 'zod'
import { CompletedChallengesPage } from '../../components'

const completedSearchSchema = z.object({
  submitted: z.string().optional(),
})

export const Route = createFileRoute('/challenges/completed')({
  component: () => <CompletedChallengesPage />,
  validateSearch: completedSearchSchema,
})
